import * as React from 'react';
import { useState } from 'react';
import { Container, StyledInput, IconContainer, Label, ErrorMessage } from './styles.js';
import { EyeIcon } from '../Icons/components/eye.js';
import { EyeOffIcon } from '../Icons/components/eyeOff.js';

const Input = ({ label , error , inputProps ={} , maskProps , width , disabled , passwordWithIcon , style , className , classNames ={} , onChange , ...props })=>{
    const [withValue, setWithValue] = useState(Boolean(inputProps.value));
    const [inputType, setInputType] = useState(passwordWithIcon ? "password" : inputProps.type || "text");
    const isMaskedInput = Boolean(maskProps && maskProps.mask);
    const handleChange = (event)=>{
        const { value  } = event.target;
        setWithValue(Boolean(value));
        if (inputProps.onChange) {
            inputProps.onChange(event);
        } else if (onChange) {
            onChange(event);
        }
    };
    const handleClickPasswordIcon = ()=>{
        if (passwordWithIcon) {
            setInputType(inputType === "password" ? "text" : "password");
        }
    };
    return /*#__PURE__*/ React.createElement(Container, {
        style: {
            width,
            ...style
        },
        className: `${className || ""} ${classNames.container || ""}`,
        ...props
    }, /*#__PURE__*/ React.createElement(StyledInput, {
        isMask: isMaskedInput,
        disabled: disabled,
        ...maskProps,
        ...inputProps,
        placeholder: label ? undefined : inputProps.placeholder,
        type: inputType,
        onChange: handleChange,
        withIconRight: passwordWithIcon,
        className: classNames.input
    }), passwordWithIcon && /*#__PURE__*/ React.createElement(IconContainer, {
        active: inputType === "text",
        onClick: handleClickPasswordIcon,
        className: classNames.iconContainer
    }, inputType === "text" ? /*#__PURE__*/ React.createElement(EyeIcon, null) : /*#__PURE__*/ React.createElement(EyeOffIcon, null)), label && /*#__PURE__*/ React.createElement(Label, {
        className: `${classNames.label}`,
        active: withValue
    }, label), error && /*#__PURE__*/ React.createElement(ErrorMessage, {
        className: classNames.error
    }, error));
};

export { Input };
